import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vendors: [],
  error: null,
  loading: false,
  admins: [],
  subscriptions: [],
  plans: [],
  categories: [],
  subCategories: [],
  notifications: [],
  unread_count: 0,
  states: [],
  cities: [],
};

const adminSlice = createSlice({
  name: "admin",
  initialState: initialState,
  reducers: {
    setVendors: (state, action) => {
      state.vendors = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    addVendor: (state, action) => {
      state.vendors.push(action.payload);
    },
    deleteVendor: (state, action) => {
      state.vendors = state.vendors.filter(
        (vendor) => vendor._id !== action.payload._id
      );
    },
    updateVendor: (state, action) => {
      state.vendors = state.vendors.map((vendor) =>
        vendor._id === action.payload._id
          ? { ...vendor, ...action.payload }
          : vendor
      );
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAdmins: (state, action) => {
      state.admins = action.payload;
    },
    addAdmins: (state, action) => {
      state.admins.push(action.payload);
    },
    deleteAdmins: (state, action) => {
      state.admins = state.admins.filter(
        (admin) => admin.id !== action.payload.id
      );
    },
    updateAdmins: (state, action) => {
      state.admins = state.admins.map((admin) =>
        admin.id === action.payload.id ? { ...admin, ...action.payload } : admin
      );
    },
    setSubScriptions: (state, action) => {
      state.subscriptions = action.payload;
    },
    deleteSubScription: (state, action) => {
      state.subscriptions = state.subscriptions.filter(
        (subscription) => subscription.id !== action.payload.id
      );
    },
    updateSubScription: (state, action) => {
      state.subscriptions = state.subscriptions.map((subscription) =>
        subscription.id === action.payload.id
          ? { ...subscription, ...action.payload }
          : subscription
      );
    },
    addSubScription: (state, action) => {
      state.subscriptions.push(action.payload);
    },
    setPlans: (state, action) => {
      state.plans = action.payload;
    },
    deletePlans: (state, action) => {
      state.plans = state.plans.filter((plan) => plan.id !== action.payload.id);
    },
    updatePlans: (state, action) => {
      state.plans = state.plans.map((plan) =>
        plan.id === action.payload.id ? { ...plan, ...action.payload } : plan
      );
    },
    addPlans: (state, action) => {
      state.plans.push(action.payload);
    },
    addCategory: (state, action) => {
      state.categories.push(action.payload);
    },
    addSubCategory: (state, action) => {
      state.subCategories.push(action.payload);
    },
    deleteCategories: (state, action) => {
      const ids = action.payload;
      state.categories = state.categories.filter(
        (category) => !ids.includes(category.id)
      );
      // state.categories = state.categories.filter(
      //   (category) => category.id !== action.payload.id
      // );
    },
    deleteSubCategories: (state, action) => {
      const ids = action.payload;
      state.subCategories = state.subCategories.filter(
        (subCategory) => !ids.includes(subCategory.id)
      );
    },

    updateCategory: (state, action) => {
      const { id, data } = action.payload;
      const index = state.categories.findIndex(
        (category) => category.id === id
      );
      if (index !== -1) {
        state.categories[index] = { ...state.categories[index], ...data };
      }
    },
    updateSubCategory: (state, action) => {
      const { id, data } = action.payload;
      const index = state.subCategories.findIndex(
        (subCategory) => subCategory.id === id
      );
      if (index !== -1) {
        state.subCategories[index] = { ...state.subCategories[index], ...data };
      }
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setSubCategories: (state, action) => {
      state.subCategories = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    // States
    setStates: (state, action) => {
      state.states = action.payload;
    },
    addState: (state, action) => {
      state.states.push(action.payload);
    },
    updateState: (state, action) => {
      const { id, data } = action.payload;
      const index = state.states.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.states[index] = { ...state.states[index], ...data };
      }
    },
    deleteStates: (state, action) => {
      const ids = action.payload;
      state.states = state.states.filter((item) => !ids.includes(item.id));
    },
    // Cities
    setCities: (state, action) => {
      state.cities = action.payload;
    },
    addCity: (state, action) => {
      state.cities.push(action.payload);
    },
    updateCity: (state, action) => {
      const { id, data } = action.payload;
      const index = state.cities.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.cities[index] = { ...state.cities[index], ...data };
      }
    },
    deleteCities: (state, action) => {
      const ids = action.payload;
      state.cities = state.cities.filter((item) => !ids.includes(item.id));
    },
    setUnreadCount: (state, action) => {
      state.unread_count = action.payload;
    },
  },
});
export const {
  setVendors,
  setError,
  setLoading,
  addVendor,
  deleteVendor,
  updateVendor,
  setAdmins,
  addAdmins,
  deleteAdmins,
  updateAdmins,
  setSubScriptions,
  deleteSubScription,
  updateSubScription,
  addSubScription,
  setPlans,
  deletePlans,
  updatePlans,
  addPlans,
  addCategory,
  addSubCategory,
  deleteCategories,
  deleteSubCategories,
  updateCategory,
  updateSubCategory,
  setCategories,
  setSubCategories,
  setNotifications,
  setStates,
  addState,
  updateState,
  deleteStates,
  setCities,
  addCity,
  updateCity,
  deleteCities,
  setUnreadCount,
} = adminSlice.actions;
export default adminSlice.reducer;
